import { Link } from 'react-router-dom';

const footerLinks = {
  sports: {
    title: '热门赛事',
    links: [
      { label: '足球竞猜', path: '/category/football' },
      { label: '篮球竞猜', path: '/category/basketball' },
      { label: '网球竞猜', path: '/category/tennis' },
      { label: '电竞竞猜', path: '/category/esports' },
      { label: '其他赛事', path: '/category/other' },
    ],
  },
  platform: {
    title: '平台服务',
    links: [
      { label: '会员福利', path: '/article/5' },
      { label: '安全指南', path: '/article/6' },
      { label: '常见问题', path: '/about' },
      { label: '关于我们', path: '/about' },
    ],
  },
  help: {
    title: '帮助中心',
    links: [
      { label: '新手指南', path: '/about' },
      { label: '充值提现', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '用户协议', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">
                华体会官网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              华体会官网是您体验顶级体育娱乐的首选平台，提供安全稳定的官方正版入口，汇聚海量体育赛事与专业竞猜服务。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-accent-700 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 华体会官网 版权所有 | 华体会官网官方正版入口
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-700 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-700 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-700 transition-colors duration-200" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}